import { render, staticRenderFns } from "./KeywordPieChart.vue?vue&type=template&id=024ad371&scoped=true"
import script from "./KeywordPieChart.vue?vue&type=script&lang=js"
export * from "./KeywordPieChart.vue?vue&type=script&lang=js"
import style0 from "./KeywordPieChart.vue?vue&type=style&index=0&id=024ad371&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024ad371",
  null
  
)

export default component.exports